var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "collapsible-item",
    { attrs: { active: _vm.isTimeTrackingRoute } },
    [
      _c(
        "template",
        { slot: "main" },
        [
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                to: { name: "time-tracking", params: { teamId: _vm.teamId } }
              }
            },
            [
              _c("q-item-side", { attrs: { icon: "timer" } }),
              _c("q-item-main", {
                attrs: {
                  label:
                    !_vm.isTimeTrackingRoute && _vm.activeTimeEntry
                      ? _vm.durationFormatted
                      : _vm.$t("time_tracking")
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "expanded" },
        [
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                exact: "",
                to: { name: "time-tracking", params: { teamId: _vm.teamId } }
              }
            },
            [_c("q-item-main", { attrs: { label: _vm.$t("overview") } })],
            1
          ),
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                exact: "",
                to: { name: "time-entries", params: { teamId: _vm.teamId } }
              }
            },
            [_c("q-item-main", { attrs: { label: _vm.$t("report") } })],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "popover" },
        [
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              attrs: {
                item: "",
                exact: "",
                to: { name: "time-tracking", params: { teamId: _vm.teamId } }
              }
            },
            [_c("q-item-main", { attrs: { label: _vm.$t("overview") } })],
            1
          ),
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              attrs: {
                item: "",
                exact: "",
                to: { name: "time-entries", params: { teamId: _vm.teamId } }
              }
            },
            [_c("q-item-main", { attrs: { label: _vm.$t("report") } })],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }